
/**
 * 
 * @hidden
 */
export enum FormModes {

    /**
     * 
     */
    Edit = 0,

    /**
     * 
     */
    Add = 1,
}
